import { useQuery } from '@tanstack/react-query';
import { useOrganization } from '@/hooks/useOrganization';
import {
  listOrdensServicoAbertas,
  atualizarEnderecoOSAbertas,
  type NovoEnderecoOS,
} from '@/services/ordens-servico-abertas.service';

export type { NovoEnderecoOS };

/**
 * Hook to read OS in "open" statuses for a given cliente.
 */
export function useOrdensServicoAbertas(clienteId: string | undefined) {
  const { organizationId } = useOrganization();

  return useQuery({
    queryKey: ['ordens-servico-abertas', organizationId, clienteId],
    queryFn: () => (clienteId ? listOrdensServicoAbertas(clienteId) : Promise.resolve([])),
    enabled: !!clienteId,
  });
}

/**
 * Returns the address-update function. Not a React Query mutation — consumer
 * awaits the returned fn directly. Shape preserved from the legacy hook so
 * `const fn = useAtualizarEnderecoOS(); await fn(clienteId, endereco);` keeps working.
 */
export function useAtualizarEnderecoOS() {
  return atualizarEnderecoOSAbertas;
}
